// Базовий домен платформи. Салони живуть на піддоменах <slug>.<PLATFORM_DOMAIN>.
// У проді задається build-time env REACT_APP_PLATFORM_DOMAIN (напр. aptme.app);
// локально — 'localhost' (тестування через clean-hands-club.localhost:3000).
export const PLATFORM_DOMAIN = (process.env.REACT_APP_PLATFORM_DOMAIN || 'localhost').toLowerCase();

// Сервісні піддомени — не салони.
const RESERVED = new Set(['app', 'api', 'www', 'admin']);

// Slug салону з поточного хоста (<slug>.<PLATFORM_DOMAIN>), інакше null.
export const salonSlugFromHost = (hostname) => {
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase();
  const base = PLATFORM_DOMAIN;
  if (!host || host === base) return null;          // корінь платформи
  if (!host.endsWith(`.${base}`)) return null;      // не наш домен
  const label = host.slice(0, -(base.length + 1));  // усе до ".base"
  if (!label || label.includes('.')) return null;   // лише один рівень піддомену
  if (RESERVED.has(label)) return null;
  return label;
};

// Чи відкрито застосунок на піддомені салону.
export const isSalonHost = (hostname) => salonSlugFromHost(hostname) != null;
